import React, { forwardRef } from 'react';
import BarcodeLabel from './BarcodeLabel';
import QrCodeLabel from './QrCodeLabel';

// SheetLabelPreview Component
const SheetLabelPreview = forwardRef(({
  labelWidth,
  labelHeight,
  gap,
  padding,
  gridColumns = 1,
  labels,
  bcid,
}, ref) => {
  const rowStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${gridColumns}, 1fr)`,
    gap: `${gap}mm`,
  };

  return (
    <div ref={ref} className="sheet-container">
      <div style={rowStyle}>
        {labels.map((lbl, index) => (
          <div
            key={index}
            className="label"
            style={{
              width: `${labelWidth}mm`,
              height: `${labelHeight}mm`,
              padding: `${padding}mm`,
              boxSizing: 'border-box',
            }}
          >
            {bcid === 'qrcode' ? (
              <QrCodeLabel
                condition={lbl?.condition}
                category={lbl?.category}
                itemName={lbl.itemName}
                itemPrice={lbl.sellingPrice}
                value={lbl.barcode}
                backgroundColor="#fffc"
                labelWidth={labelWidth}
                labelHeight={labelHeight}
                showPrice={lbl.showPrice}
                showBatteryHealth={lbl.showBatteryHealth}
                deviceMode={lbl.deviceMode}
              />
            ) : (
              <BarcodeLabel
                batteryHealth={lbl?.batteryHealth}
                condition={lbl?.condition}
                category={lbl?.category}
                itemName={lbl.itemName}
                itemPrice={lbl.sellingPrice}
                companyName={"MA Iphone Solution"}
                value={lbl.barcode}
                backgroundColor="#fffc" // Yellow background
                labelWidth={labelWidth} // Width of barcode label in mm
                labelHeight={labelHeight} // Height of barcode label in mm
                showPrice={lbl.showPrice}
                showBatteryHealth={lbl.showBatteryHealth}
                deviceMode={lbl.deviceMode}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
});

export default SheetLabelPreview;
